export const normalizeYesNo = (value) => {
  if (value == null) return 'No'

  if (Array.isArray(value)) {
    if (value.length === 0) return 'No'
    value = value[0]
  }

  const normalized = String(value).trim().toLowerCase()

  if (normalized === 'yes' || normalized === 'y') {
    return 'Yes'
  }

  return 'No'
}

export const getAnswersMap = (answersList = []) => {
  return answersList.reduce((acc, item) => {
    if (!item) return acc

    const key = item.saveKey || item.stepId

    if (!key) return acc

    acc[key] =
      item.extractedValue ??
      item.value ??
      item.text ??
      item.photoUrl ??
      null

    if (item.canonicalData) {
      acc[`${key}Canonical`] = item.canonicalData
    }

    return acc
  }, {})
}

export const getFinalHairClass = (answersMap) => {
  const predictedHairClass =
    answersMap?.hairPrediction?.predictedHairClass || null

  const correctedHairClass = answersMap?.correctedHairClass || null

  const isPredictionCorrect =
    answersMap?.isPredictedHairClassCorrect || null

  if (
    String(isPredictionCorrect).trim().toLowerCase() === 'no' &&
    correctedHairClass
  ) {
    return correctedHairClass
  }

  return predictedHairClass
}

export const toFlatList = (value) => {
  if (Array.isArray(value)) {
    const cleaned = value.flat().filter(Boolean)
    return cleaned.length ? cleaned : ['None']
  }

  return value ? [value] : ['None']
}

export const getAgeCategory = (ageValue) => {
  const age = Number(ageValue)

  if (Number.isNaN(age) || age < 0) return null
  if (age <= 1) return '0-1 year'
  if (age <= 5) return '2-5 years'
  if (age <= 12) return '6-12 years'
  if (age <= 17) return '13-17 years'
  if (age <= 24) return '18-24 years'
  if (age <= 44) return '25-44 years'
  if (age <= 64) return '45-64 years'

  return '65 years and over'
}